<div class="login-page">
  <div class="login-page__container">
    <app-secondary-logo />
    <div class="login-form__container">
      <app-login-form />
    </div>
  </div>
  <div class="feedback__container">
    <app-feedback-list />
  </div>
</div>
